import React, { useEffect, useState } from "react";
import { useGetClientLogoMutation } from "../../../store/action/client";
import { useGetClientMutation } from "../../../store/action/client";
import ClientUserProfile from "./ClientUserProfile";

const EditClientProfileWrapper = (props) => {
  const { id } = props;
  const [userInput, setUserInput] = useState({
    initialLoad: false,
    editData: {},
    clientLogo: "",
  });
  const [getClientApi, { isLoading: isGetLoading }] = useGetClientMutation();
  const [getClientLogoApi] = useGetClientLogoMutation();

  useEffect(() => {
    if (!userInput.initialLoad) {
      if (!isGetLoading) {
        if (id) {
          getInitialDataFromApi();
        }
      }
      setUserInput({ ...userInput, initialLoad: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInitialDataFromApi = async () => {
    const { data: { imageUrl = "" } = {} } = await getClientLogoApi(props?.id);
    await getClientApi(props?.id).then((res) => {
      setUserInput({ ...userInput, editData: res, clientLogo: imageUrl });
    });
  };
  if (id && !userInput?.editData?.data) {
    return null;
  }

  return (
    <ClientUserProfile
      editData={userInput.editData}
      setUserInput={setUserInput}
      userInput={userInput}
      id={id}
    />
  );
};

export default EditClientProfileWrapper;
